import Api from "./api.js";

export default {
  getContractors() {
    return Api().get(`/api/contractors`);
  },
  addContractor(contractor) {
    return Api().post("/api/contractors", contractor);
  },
  deleteContractor(contractor) {
    return Api().put(`/api/contractors/${contractor.id}`, contractor);
  },
  getContractorByID(contractorID) {
    return Api().get(`/api/contractors/${contractorID}`);
  },
  updateContractor(contractor) {
    return Api().put(`/api/contractors/${contractor.id}`, contractor);
  },
  getInvoices(seasonFrom, seasonTo) {
    return Api().get(`/api/invoices/?seasonFrom[after]=${seasonFrom}&seasonFrom[before]=${seasonTo}`);
  },
  addInvoice(invoice) {
    return Api().post('/api/invoices', invoice);
  },
  updateInvoice(invoice) {
    return Api().put(`/api/invoices/${invoice.id}`, invoice);
  },
  deleteInvoice(invoice) {
    return Api().delete(`/api/invoices/${invoice.id}`);
  },
  getPDF(contractor, date) {
    return Api().post("/api/pdf/export", {contractor: contractor, date: date}, { responseType: "blob" });
  },
  getXML(listOfPeople) {
    return Api().post("/api/xml/export", listOfPeople, { responseType: "blob" });
  },
  updateRole(personID, type, role) {
    return Api().put(`/people/${personID}/${type}`, role);
  },
  changePassword(newUser) {
    return Api().put("/changePassword", newUser);
  },
  authUser(user) {
    return Api().post("/auth/login", user);
  },
  sendMails(contractor, date, isAccounting, accountantMail) {
    return Api().post("/api/mail/send", {contractor: contractor, date: date, isAccounting: isAccounting, accountantMail: accountantMail});
  },
  sendMailsToAccountant(contractors, date) {
    return Api().post("/api/mail/sendToAccountant", {contractors: contractors, date: date, toAccountant: true});
  },
};
